import { widgetRegistry } from '@features/widgets/WidgetRegistry';
import { kpiWidgetDef } from './kpi/KpiWidget';
import { lineWidgetDef } from './charts/LineWidget';
import { barWidgetDef } from './charts/BarWidget';
import { pieWidgetDef } from './charts/PieWidget';
import { areaWidgetDef } from './charts/AreaWidget';
import { gaugeWidgetDef } from './charts/GaugeWidget';
import { tableWidgetDef } from './table/TableWidget';
import { activityWidgetDef } from './activity-feed/ActivityFeedWidget';
import { notificationWidgetDef } from './notification/NotificationWidget';
import { mapWidgetDef } from './map/MapWidget';
import { markdownWidgetDef } from './markdown/MarkdownWidget';
import { customWidgetDef } from './custom/CustomWidget';
import { scatterWidgetDef } from './charts/ScatterWidget';
import { bubbleWidgetDef } from './charts/BubbleWidget';
import { radarWidgetDef } from './charts/RadarWidget';
import { boxplotWidgetDef } from './charts/BoxplotWidget';
import { heatmapWidgetDef } from './charts/HeatmapWidget';
import { candlestickWidgetDef } from './charts/CandlestickWidget';
import { sankeyWidgetDef } from './charts/SankeyWidget';
import { funnelWidgetDef } from './charts/FunnelWidget';
import { treeWidgetDef } from './charts/TreeWidget';
import { treemapWidgetDef } from './charts/TreemapWidget';
import { sunburstWidgetDef } from './charts/SunburstWidget';
import { graphWidgetDef } from './charts/GraphWidget';
import { parallelWidgetDef } from './charts/ParallelWidget';
import { calendarWidgetDef } from './charts/CalendarWidget';
import { themeRiverWidgetDef } from './charts/ThemeRiverWidget';
import { pictorialBarWidgetDef } from './charts/PictorialBarWidget';
import { nightingaleWidgetDef } from './charts/NightingaleWidget';
import { waterfallWidgetDef } from './charts/WaterfallWidget';

widgetRegistry.register(kpiWidgetDef);
widgetRegistry.register(lineWidgetDef);
widgetRegistry.register(barWidgetDef);
widgetRegistry.register(pieWidgetDef);
widgetRegistry.register(areaWidgetDef);
widgetRegistry.register(gaugeWidgetDef);
widgetRegistry.register(tableWidgetDef);
widgetRegistry.register(activityWidgetDef);
widgetRegistry.register(notificationWidgetDef);
widgetRegistry.register(mapWidgetDef);
widgetRegistry.register(markdownWidgetDef);
widgetRegistry.register(customWidgetDef);
widgetRegistry.register(scatterWidgetDef);
widgetRegistry.register(bubbleWidgetDef);
widgetRegistry.register(radarWidgetDef);
widgetRegistry.register(boxplotWidgetDef);
widgetRegistry.register(heatmapWidgetDef);
widgetRegistry.register(candlestickWidgetDef);
widgetRegistry.register(sankeyWidgetDef);
widgetRegistry.register(funnelWidgetDef);
widgetRegistry.register(treeWidgetDef);
widgetRegistry.register(treemapWidgetDef);
widgetRegistry.register(sunburstWidgetDef);
widgetRegistry.register(graphWidgetDef);
widgetRegistry.register(parallelWidgetDef);
widgetRegistry.register(calendarWidgetDef);
widgetRegistry.register(themeRiverWidgetDef);
widgetRegistry.register(pictorialBarWidgetDef);
widgetRegistry.register(nightingaleWidgetDef);
widgetRegistry.register(waterfallWidgetDef);
